import { render, staticRenderFns } from "./info.vue?vue&type=template&id=551005d9&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports